import { render, staticRenderFns } from "./PracticeResultView.vue?vue&type=template&id=724d0194&scoped=true&"
import script from "./PracticeResultView.vue?vue&type=script&lang=js&"
export * from "./PracticeResultView.vue?vue&type=script&lang=js&"
import style0 from "./PracticeResultView.vue?vue&type=style&index=0&id=724d0194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d0194",
  null
  
)

/* custom blocks */
import block0 from "./PracticeResultView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports